import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    title: {
        id: 'iaso.polio.repository.title',
        defaultMessage: 'Vaccine Management Repository',
    },
    roundNumbers: {
        id: 'iaso.polio.form.label.roundNumbers',
        defaultMessage: 'Round number(s)',
    },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    obr_name: {
        id: 'iaso.polio.form.label.obrName',
        defaultMessage: 'OBR Name',
    },
    round: {
        id: 'iaso.polio.label.round',
        defaultMessage: 'Round',
    },
    startDate: {
        id: 'iaso.label.dateFrom',
        defaultMessage: 'Start date',
    },
    notRequired: {
        id: 'iaso.polio.label.notRequired',
        defaultMessage: 'Not required',
    },
    all: {
        id: 'iaso.forms.all',
        defaultMessage: 'All',
    },
    preAlerts: {
        id: 'iaso.polio.label.PREALERT',
        defaultMessage: 'Pre-alerts',
    },
    vrf: {
        id: 'iaso.polio.label.vrfTitle',
        defaultMessage: 'Vaccine request form',
    },
    formA: {
        id: 'iaso.polio.label.formA',
        defaultMessage: 'Form A',
    },
    ongoingCampaigns: {
        id: 'iaso.polio.label.ongoingCampaigns',
        defaultMessage: 'Ongoing campaigns',
    },
    pastCampaigns: {
        id: 'iaso.polio.label.pastCampaigns',
        defaultMessage: 'Past campaigns',
    },
    preparing: {
        id: 'iaso.polio.label.preparing',
        defaultMessage: 'Preparing',
    },
    missing: {
        id: 'iaso.polio.label.vrfTypeMissing',
        defaultMessage: 'Missing',
    },
    incidentReports: {
        id: 'iaso.polio.label.incidentReports',
        defaultMessage: 'Incident reports',
    },
    destructionReports: {
        id: 'iaso.polio.label.destructionReports',
        defaultMessage: 'Destruction reports',
    },
    vaccine: {
        id: 'iaso.polio.vaccine',
        defaultMessage: 'Vaccine',
    },
    forms: {
        id: 'iaso.forms.title',
        defaultMessage: 'Forms',
    },
    reports: {
        id: 'iaso.polio.reports',
        defaultMessage: 'Reports',
    },
    noPdf: {
        id: 'iaso.polio.repository.noPdf',
        defaultMessage: 'No pdf',
    },
    withPdf: {
        id: 'iaso.polio.repository.withPdf',
        defaultMessage: 'With pdf',
    },
    formAisLate: {
        id: 'iaso.polio.repository.formAisLate',
        defaultMessage: 'Form A is late',
    },
    dateNotFound: {
        id: 'iaso.polio.repository.dateNotFound',
        defaultMessage: 'Date not found',
    },
});

export default MESSAGES;
